module.exports = __webpack_public_path__ + "static/charishma-fe1359ffe01265058f9f34345c661f25.jpg";